import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";

const DeemedHeaderSection = ({ collegeName, universityDescription }) => {
 return (
  <Box bg="gray.50" py={8} px={6} borderBottom="1px" borderColor="gray.200">
   <Text as="h1" fontSize={{ base: "20px", md: "20px" }} mb={3}>
    Why Choose{" "}
    <Box as="span" color="red.600">
     {collegeName || "This College"}
    </Box>
    ?
   </Text>

   <Text fontSize={{ base: "md", md: "lg" }} color="gray.600">
    {universityDescription ||
     "A premier educational institution focused on academic excellence and holistic development."}
   </Text>
  </Box>
 );
};

export default DeemedHeaderSection;
